import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Recaptcha from 'react-recaptcha'

import config from '../../../config'

import style from '../style'

export const ContactForm = props => (
  <form onSubmit={props.onFormSubmit}>
    <Row>
      <Col xs='12' md='6'>
        <FormGroup>
          <label className={css(style.form.label)}>Full Name *</label>
          <Input
            type={`text`}
            name={`fullName`}
            value={props.editor.fullName}
            onChange={props.onInputChange}
            className={css(style.form.input, style.form.singleRowInput)}
          />
        </FormGroup>
      </Col>
      <Col xs='12' md='6'>
        <FormGroup>
          <label className={css(style.form.label)}>Email Address *</label>
          <Input
            type={`text`}
            name={`email`}
            value={props.editor.email}
            onChange={props.onInputChange}
            className={css(style.form.input, style.form.singleRowInput)}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <FormGroup>
          <label className={css(style.form.label)}>Subject *</label>
          <Input
            type={`text`}
            name={`title`}
            value={props.editor.title}
            onChange={props.onInputChange}
            className={css(style.form.input, style.form.singleRowInput)}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <FormGroup>
          <label className={css(style.form.label)}>Message *</label>
          <Input
            type={`textarea`}
            cols={`20`}
            rows={`10`}
            name={`content`}
            value={props.editor.content}
            onChange={props.onInputChange}
            className={css(style.form.input)}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <FormGroup>
          <Recaptcha
            sitekey={config.recaptcha_sitekey}
            verifyCallback={props.onCaptchaVerify}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <input type='submit' value='Send' className={css(style.form.submit)} />
      </Col>
    </Row>
  </form>
)

export default ContactForm



// WEBPACK FOOTER //
// ./src/components/Contact/partials/ContactForm.js